import React from 'react';
import Translate from 'react-translate-component';
import { map, keys } from 'ramda';
import { Badge, Menu } from 'antd';
import { Link } from 'react-router-dom';
import { withRouter } from 'react-router';

import { notEmpty } from 'utils/ramdaAdditions';

export const TabsStatusFilter = withRouter(({ match: { params }, counters, defaultFilters, route, translate = 'approvals', routeParams = {} }) => (
    <Menu mode="horizontal" className="menu-tabs" selectedKeys={[params.status]}>
        { map((status) => (
            <Menu.Item key={ status }>
                <Link to={route.stringify({ status, ...routeParams })}>
                    <Translate content={`filterStatus.${translate}.${status}` } component="span" />
                    { notEmpty(counters) &&
                        <span className="hidden-sm">
                            <Badge count={ counters[status] } />
                        </span>
                    }
                </Link>
            </Menu.Item>
        ), keys(defaultFilters)) }
    </Menu>
));
